import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderLeftOutlinedSvg from "@ant-design/icons-svg/es/asn/BorderLeftOutlined";
import AntdIcon from '../components/AntdIcon';
var BorderLeftOutlined = function BorderLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: BorderLeftOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(BorderLeftOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'BorderLeftOutlined';
}
export default RefIcon;